import { styled } from "@mui/material/styles";

import Loader from "src/common/components/Loader";

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "24px",
}));

export const TableLoader = ({ message }: { message: string }) => {
  return (
    <LoadingContainer>
      <div style={{ transform: "scale(0.4)" }} key="loader">
        <Loader />
      </div>
      <span key="loader-message">{message}</span>
    </LoadingContainer>
  );
};
